module.exports = __webpack_public_path__ + "static/media/plus.57b0f6e3.svg";